export const LAYOUT_VERTICAL_PADDING = 'space-40';
